<template>
  <div class="row">
    <div class="col-12">
      <div class="col-12">
        <p><strong>Visual Alerts is not enabled for your account.</strong></p>
        <h3>G2 Visual Alerts</h3>
        <p>G2 Visual Alerts allows for instant visual communication anytime and anywhere. It enables administrators to deploy timely notifications to any enabled device within the ecosystem, both on- and off-campus.</p>
        <h4>How does it work?</h4>
        <p>With just a few clicks from an internet-ready or mobile device, administrators can initiate text, image, and video messages to any enrolled device within seconds. The G2 Communicator application makes it easy to manage and customize G2 Visual Alerts, and alerts can be triggered from any device or mobile phone. </p>
        <h4>Features</h4>
        <ul>
          <li>Compatible with Android, Linux, Mac OS, Windows, and Chrome</li>
          <li>Runs in the background</li>
          <li>Customizable text, images, colors, and more</li>
          <li>Ability to deploy messages to a single device or to a group</li>
        </ul>
        <p>Upgrade your communication and security capabilities with G2 Visual Alerts.</p>
        <p><strong>For more information, please visit our website at <a href="https://www.galaxynext.us/">https://www.galaxynext.us/</a>, or contact us at <a href="mailto:sales@galaxynext.us">sales@galaxynext.us</a> to get started.</strong></p>
      </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
    })
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  },
  mounted () {
    if (this.feature_visual_alert_enabled) {
      this.$router.push({ name: 'AlertIndex' })
    }
  }
}
</script>